module.exports = __webpack_public_path__ + "static/media/quarrytruck4.85aff0c9.jpg";